import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-export',
  standalone: true,
  imports: [],
  templateUrl: './icon-export.component.html',
  styleUrl: './icon-export.component.scss'
})
export class IconExportComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24px';
}
